import {
    SET_MAPPING_OPTIONS,
    SET_CURRENT_STEP,
    UPDATE_BULK_DATA,
    CLEAR_DATA,
    UPDATE_HEADER_MAPPING,
    TOGGLE_PRODUCT_SERVICE
} from '../actions/types';

const initialState = {
    mappingOptions: {},
    currentStep: 0,
    packagingMapping: {},
	headerMapping: {},
    bulkUploadServices: false
};


export default (state = initialState, action) => {
	const payload = action.payload;

    switch (action.type) {
        case SET_MAPPING_OPTIONS: {
            let newState = {...state};
            newState.mappingOptions = payload.mappingOptions;
            newState.fileId = payload.fileId;
            return newState;
        }
        case UPDATE_HEADER_MAPPING: {
            let newState = {...state};
            newState.headerMapping = payload;
            return newState;
        }
        case SET_CURRENT_STEP: {
            let newState = {
                ...state,
                currentStep: payload.currentStep
            };
            return newState;
        }
        case UPDATE_BULK_DATA: {
            let newState = {...state};
            newState = {
                ...newState,
                ...payload
            }
            return newState;
        }
        case CLEAR_DATA: {
            let newState = {...state};
            newState = initialState;
            return newState;
        }
        case TOGGLE_PRODUCT_SERVICE: {
            let newState = {...state};
            newState.bulkUploadServices = payload.bulkUploadServices
            return newState;
        }
        default:
			return state;
    }
}